import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

export const Chat = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border-radius: 24px;
  position: relative;
  grid-column: 1 / 3;
  column-span: 2;
  align-items: center;
  pointer-events: none;
  justify-content: flex-end;
  gap: 20px;
`;
export const ChatLog = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
  * {
    pointer-events: auto;
  }
`;
export const InputArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 0.5rem;
  width: 100%;
`;
export const ResendWrapper = styled.div`
  color: #fff;
  text-shadow: 1px 1px black;
`;

export const SessionCompleteItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const FeedbackTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.5s;
  user-select: text;
`;
export const FeedbackText = styled.div`
  background-color: ${({ theme }) => theme.color.secondary};
  color: ${({ theme }) => theme.color.contrast.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;
